import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/solid";
import { packClasses } from "Utils";

export default function DropdownMenu({ label, menuItems, ...remainder }) {
    const variants = {
        primary:
            "border-transparent bg-green-600 text-white hover:bg-green-700",
        secondary: "border-gray-300 bg-white text-gray-700 hover:bg-gray-50",
    };

    let variant;
    switch (remainder.variant) {
        case "primary":
            variant = variants.primary;
            break;
        case "secondary":
        default:
            variant = variants.secondary;
    }

    return (
        <Menu as="div" className="relative text-left" {...remainder}>
            {({ open }) => (
                <Fragment>
                    <div>
                        <Menu.Button
                            className={packClasses(
                                "focus:outline-none flex w-full justify-center rounded-md border  px-4 py-2 text-sm font-medium  shadow-sm  focus:ring-2 focus:ring-green-500 focus:ring-offset-2 focus:ring-offset-gray-100",
                                "disabled:opacity-50",
                                variant,
                                remainder.className
                            )}
                            disabled={remainder.disabled}
                        >
                            <span className="flex-grow">{label}</span>
                            <ChevronDownIcon
                                className="-mr-1 ml-2 h-5 w-5"
                                aria-hidden="true"
                            />
                        </Menu.Button>
                    </div>

                    <Transition
                        show={open}
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                    >
                        <Menu.Items
                            static
                            className="focus:outline-none absolute left-0 z-10 mt-2 w-56 origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5"
                        >
                            <div className="py-1">
                                {menuItems.map((child, i) => (
                                    <Menu.Item key={i}>
                                        {({ active }) => (
                                            <div
                                                className={packClasses(
                                                    active
                                                        ? "bg-gray-100 text-gray-900"
                                                        : "text-gray-700",
                                                    "block cursor-pointer px-4 py-2 text-sm"
                                                )}
                                            >
                                                {child}
                                            </div>
                                        )}
                                    </Menu.Item>
                                ))}
                            </div>
                        </Menu.Items>
                    </Transition>
                </Fragment>
            )}
        </Menu>
    );
}
